// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pagination-blog-posts-by-category-js": () => import("./../../../src/pagination/blog-posts-by-category.js" /* webpackChunkName: "component---src-pagination-blog-posts-by-category-js" */),
  "component---src-pagination-blog-posts-js": () => import("./../../../src/pagination/blog-posts.js" /* webpackChunkName: "component---src-pagination-blog-posts-js" */),
  "component---src-templates-blog-post-js": () => import("./../../../src/templates/blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */)
}

